interface FormEditarPromocion {
    idtblPersonasAutorizadas: number;
    idCarpetaJudicial: string;
    idSolicitudActuacion: string;
    cveTipoCarpeta: string;
    numero: string;
    anio: string;
    cveAdscripcion: string;
    nombresFirmantes: any[];
}

export const formRedirectEditarPromocion = (url: string | undefined, params: FormEditarPromocion) => {
    if (!url) return;
    let form = document.createElement("form");
    form.setAttribute("target", "_blank");
    form.setAttribute("action", url);
    form.setAttribute("method", "POST");

    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", "idtblPersonasAutorizadas");
    hiddenField.setAttribute("value", String(params.idtblPersonasAutorizadas));
    form.appendChild(hiddenField);

    let hiddenField2 = document.createElement("input");
    hiddenField2.setAttribute("type", "hidden");
    hiddenField2.setAttribute("name", "idSolicitudActuacion");
    hiddenField2.setAttribute("value", String(params.idSolicitudActuacion));
    form.appendChild(hiddenField2);

    let hiddenField3 = document.createElement("input");
    hiddenField3.setAttribute("type", "hidden");
    hiddenField3.setAttribute("name", "idCarpetaJudicial");
    hiddenField3.setAttribute("value", String(params.idCarpetaJudicial));
    form.appendChild(hiddenField3);

    let hiddenField4 = document.createElement("input");
    hiddenField4.setAttribute("type", "hidden");
    hiddenField4.setAttribute("name", "cveTipoCarpeta");
    hiddenField4.setAttribute("value", String(params.cveTipoCarpeta));
    form.appendChild(hiddenField4);

    let hiddenField5 = document.createElement("input");
    hiddenField5.setAttribute("type", "hidden");
    hiddenField5.setAttribute("name", "numero");
    hiddenField5.setAttribute("value", String(params.numero));
    form.appendChild(hiddenField5);

    let hiddenField6 = document.createElement("input");
    hiddenField6.setAttribute("type", "hidden");
    hiddenField6.setAttribute("name", "anio");
    hiddenField6.setAttribute("value", String(params.anio));
    form.appendChild(hiddenField6);

    let hiddenField7 = document.createElement("input");
    hiddenField7.setAttribute("type", "hidden");
    hiddenField7.setAttribute("name", "cveAdscripcion");
    hiddenField7.setAttribute("value", String(params.cveAdscripcion));
    form.appendChild(hiddenField7);

    let hiddenField8 = document.createElement("input");
    hiddenField8.setAttribute("type", "hidden");
    hiddenField8.setAttribute("name", "nombresFirmantes");
    hiddenField8.setAttribute("value", JSON.stringify(params.nombresFirmantes));
    form.appendChild(hiddenField8);
    
    document.body.appendChild(form);
    form.submit();
}